<template>
  <div class="story-gallery">
    <div v-for="(image, index) in imagesArray" :key="image + index" class="story-gallery__image" v-show="index === currentPic">
      <img :src="image" v-bind="imageDisable ? { 'data-disabled-interactive': '' } : {}" />
    </div>
    <div
      v-if="imagesArray.length > 1"
      class="story-gallery__thumbs"
    >
      <img
        v-for="(image, index) in imagesArray"
         :key="image + index"
         :src="image"
         :class="['story-gallery__thumbs-item', {'story-gallery__thumbs-item_current': index === currentPic}]"
         @click="setCurrent(index)"
      />
    </div>
  </div>
</template>

<script>
export default {
  name: 'StoryGallery',
  components: {
  },
  props: {
    imagesArray: {
      type: Array,
      default: () => [],
    },
    currentSlide: {
      type: Number,
      default: 0,
    },
    imageDisable: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      currentPic: 0,
    }
  },
  watch: {
    currentSlide() {
      this.currentPic = 0;
    }
  },
  methods: {
    setCurrent(index) {
      this.currentPic = index;
    }
  }
}
</script>
